<script setup>
  import { ref, onMounted } from 'vue';

  import { useSpotStore } from "@/stores/SpotStore";
  import { useOnsiteReportsStore } from '@/stores/OnsiteReportsStore';

  import useLegacyBridge from "@/composables/useLegacyBridge";
  import useConfigurationGlobals from '@/composables/useConfigurationGlobals';

  const content = defineModel('content');
  
  const spotStore = useSpotStore();
  const onsiteReportsStore = useOnsiteReportsStore();
  
  const { $SITENAME, $FACEBOOKAPPID } = useConfigurationGlobals();
  const { onsiteReportsList } = useLegacyBridge();

  const contentContainer = ref(null);
  
  function loadOnsiteReports() {
    const settings = {
      maxDistance: 19,
      lat: spotStore.lat,
      lon: spotStore.lon,
      listDescMaxCharacters: 135,
      mapClicked: function (report) {
          window.location = "/map#" + report.lat + "," + report.lon + ",10,12"
      },
      mapSize: [400, 200],
      onsiteReportClicked: function (report) {
          if (report.hasOwnProperty("short_url")) {
              window.open(report.short_url);
          }
      },
      socialButtons: ['facebook', 'twitter', 'email', 'copy'],
      social: {
          email: {
              subject: "OnSite Report from " + $SITENAME
          },
          facebook: {
              appId: $FACEBOOKAPPID,
              desc: "OnSite Report posted from " + $SITENAME + ". Follow link for location and more information.",
              caption: $SITENAME
          }
      },
      hideContentOnNoReports: true,
      onsiteReportsData: {...onsiteReportsStore.onsiteReportsData}
    }       
    
    content.value = onsiteReportsList(contentContainer.value, settings);
  }

  onMounted(() => loadOnsiteReports());
</script>

<template>
  <div
    class="jwx-data-container__content"
    style="width: 100%;"
    ref="contentContainer"
  ></div>
</template>